/**
 * Иконки дизайн-системы: контурные, 16×16, толщина 1.5, цвет — currentColor
 * (класс `svg.i` в styles/crm.css). Контуры взяты из макетов, а не из библиотеки: набор
 * маленький, и пакет на сотни иконок ради двух десятков — лишний вес бандла.
 */
const PATHS = {
  sales: 'M2 12l4-4 3 3 5-6M10 5h4v4',
  finance: 'M4 1.5h5.5L12 4v10.5H4zM9.5 1.5V4H12M6 8h4M6 10.5h4',
  stock: 'M2 4.5L8 1.5l6 3v7l-6 3-6-3zM2 4.5l6 3 6-3M8 7.5v7',
  hr: 'M6 7a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5zM1.5 14c0-2.5 2-4 4.5-4s4.5 1.5 4.5 4M11 2.2a2.5 2.5 0 0 1 0 4.6M12.5 10c1.3.5 2 1.8 2 4',
  analytics: 'M2 14h12M4 11V7M7 11V3M10 11V8M13 11V5',
  payments: 'M1.5 4h13v8h-13zM1.5 6.5h13M4 10h3',
  work: 'M2.5 2.5h11v11h-11zM5 8l2 2 4-4',
  admin: 'M2 4h6M11 4h3M9.5 2.5v3M2 12h2M7 12h7M5.5 10.5v3',
  chevron: 'M4 6l4 4 4-4',
  search: 'M7 12a5 5 0 1 0 0-10a5 5 0 0 0 0 10zM14 14l-3.5-3.5',
  bell: 'M4 6.5a4 4 0 0 1 8 0c0 3 1.5 4.5 1.5 4.5h-11S4 9.5 4 6.5zM6.5 13.5a1.6 1.6 0 0 0 3 0',
  sun: 'M11 8a3 3 0 1 1-6 0a3 3 0 1 1 6 0M8 1.5V3M8 13v1.5M1.5 8H3M13 8h1.5M3.4 3.4l1.1 1.1M11.5 11.5l1.1 1.1M3.4 12.6l1.1-1.1M11.5 4.5l1.1-1.1',
  moon: 'M13.5 9.5A5.5 5.5 0 0 1 6.5 2.5a5.5 5.5 0 1 0 7 7z',
  monitor: 'M1.5 2.5h13v8.5h-13zM5.5 14h5M8 11v3',
  'sidebar-collapse': 'M2.5 2.5h11v11h-11zM6 2.5v11M10.5 6L8.5 8l2 2',
  'sidebar-expand': 'M2.5 2.5h11v11h-11zM6 2.5v11M9 6l2 2-2 2',
  logout: 'M6 2.5H3v11h3M10 5l3 3-3 3M13 8H6',
  plus: 'M8 3v10M3 8h10',
  'arrow-left': 'M13 8H3M7 4L3 8l4 4',
  'arrow-right': 'M3 8h10M9 4l4 4-4 4',
  alert: 'M8 1.5l6.5 12h-13zM8 6v3.5M8 11.5v.5',
  lock: 'M4 7V5a4 4 0 0 1 8 0v2M3 7h10v7H3z',
  settings: 'M8 10a2 2 0 1 0 0-4a2 2 0 0 0 0 4zM8 1.5v2M8 12.5v2M1.5 8h2M12.5 8h2M3.4 3.4l1.4 1.4M11.2 11.2l1.4 1.4M3.4 12.6l1.4-1.4M11.2 4.8l1.4-1.4',
  inbox: 'M1.5 9.5l2-6h9l2 6v4h-13zM1.5 9.5H5l1 2h4l1-2h3.5',
  check: 'M3 8.5l3 3 7-7',
  clock: 'M8 14.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13zM8 4.5V8l2.5 1.5',
  // record card (Deal.dc.html, CompRecord.dc.html, CompActions.dc.html)
  phone: 'M3 2h3l1 3-1.5 1a8 8 0 0 0 3.5 3.5L10 8l3 1v3a1.5 1.5 0 0 1-1.5 1.5A10 10 0 0 1 1.5 3.5A1.5 1.5 0 0 1 3 2z',
  mail: 'M1.5 3.5h13v9h-13zM1.5 4l6.5 5 6.5-5',
  comment: 'M2 3h12v8H6l-3 3v-3H2z',
  flag: 'M3 14V2M3 2.5h9l-2 3 2 3H3',
  building: 'M2.5 14.5V2.5h7v12M9.5 6.5h4v8M1.5 14.5h13M5 5h2M5 8h2M5 11h2',
  user: 'M8 8a3 3 0 1 0 0-6a3 3 0 0 0 0 6zM2.5 14.5c0-3 2.5-4.5 5.5-4.5s5.5 1.5 5.5 4.5',
  copy: 'M5 5h8.5v8.5H5zM3 11V2.5h8',
  more: 'M3.5 8h.01M8 8h.01M12.5 8h.01',
  trash: 'M2.5 4h11M6 4V2.5h4V4M4 4l.7 10h6.6L12 4',
  close: 'M4 4l8 8M12 4l-8 8',
  link: 'M6.5 9.5l3-3M7 4.5l1-1a2.5 2.5 0 0 1 3.5 3.5l-1 1M9 11.5l-1 1A2.5 2.5 0 0 1 4.5 9l1-1',
  refresh: 'M13.5 8a5.5 5.5 0 1 1-1.6-3.9M13.5 2.5v3h-3',
  file: 'M4 1.5h5.5L12 4v10.5H4zM9.5 1.5V4H12M6 8h4M6 10.5h4',
  // «Мой день» и дашборд руководителя (MyDay.dc.html, Dashboard.dc.html).
  call: 'M3 2h3l1 3-1.5 1a8 8 0 0 0 3.5 3.5L10 8l3 1v3a1.5 1.5 0 0 1-1.5 1.5A10 10 0 0 1 1.5 3.5A1.5 1.5 0 0 1 3 2z',
  meet: 'M2 3.5h12v10H2zM2 6.5h12M5 2v3M11 2v3',
  'no-step': 'M3 14V2M3 2.5h9l-2 3 2 3H3',
  // lists & kanban (design)
  filter: 'M2 3h12l-4.5 5.5V13l-3-1.5v-3z',
  columns: 'M2 2.5h12v11H2zM6 2.5v11M10 2.5v11',
  lines: 'M2 3h12M2 8h12M2 13h12',
  download: 'M8 2v8M4.5 6.5L8 10l3.5-3.5M2.5 13.5h11',
  upload: 'M8 10V2M4.5 5.5L8 2l3.5 3.5M2.5 13.5h11',
  segments: 'M8 14.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13zM8 1.5V8h6.5',
  board: 'M2.5 2.5h3v11h-3zM6.5 2.5h3v7h-3zM10.5 2.5h3v9h-3z',
  'arrow-up': 'M8 13V3M4 7l4-4 4 4',
  'arrow-down': 'M8 3v10M4 9l4 4 4-4',
  box: 'M2 4.5L8 1.5l6 3v7l-6 3-6-3zM2 4.5l6 3 6-3M8 7.5v7',
  // warehouse documents (Receiving, Shipment, Picking, Inventory, Transfer.dc.html)
  truck: 'M1.5 4h8v7h-8zM9.5 6.5h3l2 2.5V11h-5M4 13a1.3 1.3 0 1 0 0-2.6A1.3 1.3 0 0 0 4 13zM11.5 13a1.3 1.3 0 1 0 0-2.6a1.3 1.3 0 0 0 0 2.6z',
  scan: 'M2 3v10M4.5 3v10M6 3v10M8.5 3v10M11 3v10M12.5 3v10M14 3v10',
  // Карточки продаж и финансов (Lead, Quote, PrimaryDoc, Contract, Payment .dc.html).
  convert: 'M4 2v4a4 4 0 0 0 4 4h4M4 14V9M10 7l3 3-3 3',
  sign: 'M2 12.5c2-3 3.5-3 4.5-1s2.5 2 4 0M10 3l3 3',
  send: 'M14 2L7 9M14 2l-4.5 12-2.5-5-5-2.5z',
  edit: 'M11.5 2.5l2 2L6 12H4v-2z',
  eye: 'M1.5 8s2.5-4.5 6.5-4.5S14.5 8 14.5 8 12 12.5 8 12.5 1.5 8 1.5 8zM8 10a2 2 0 1 0 0-4a2 2 0 0 0 0 4z',
  archive: 'M2 4h12v3H2zM3 7v6.5h10V7M6.5 9.5h3',
  // Администрирование (AdmUsers … AdmFields, CompExtra.dc.html)
  'adm-edit': 'M11.5 2.5l2 2L6 12H4v-2z',
  'adm-minus': 'M4 8h8',
  'adm-grip': 'M6 4h.01M10 4h.01M6 8h.01M10 8h.01M6 12h.01M10 12h.01',
  'adm-eye': 'M1.5 8s2.5-4.5 6.5-4.5S14.5 8 14.5 8 12 12.5 8 12.5 1.5 8 1.5 8zM8 10a2 2 0 1 0 0-4a2 2 0 0 0 0 4z',
  'adm-archive': 'M2 4h12v3H2zM3 7v6.5h10V7M6.5 9.5h3',
  'adm-users': 'M6 7a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5zM1.5 14c0-2.5 2-4 4.5-4s4.5 1.5 4.5 4M11 2.2a2.5 2.5 0 0 1 0 4.6M12.5 10c1.3.5 2 1.8 2 4',
  'adm-calendar': 'M2 3.5h12v10H2zM2 6.5h12M5 2v3M11 2v3',
  'adm-key': 'M6.5 9.5l3-3M7 4.5l1-1a2.5 2.5 0 0 1 3.5 3.5l-1 1M9 11.5l-1 1A2.5 2.5 0 0 1 4.5 9l1-1',
  'adm-login': 'M3 8h10M9 4l4 4-4 4',
  'adm-hash': 'M3 6h10M3 10h10M6.5 2.5l-1 11M10.5 2.5l-1 11',
  'adm-date': 'M2 3.5h12v10H2zM2 6.5h12M5 2v3M11 2v3',
  'adm-bool': 'M2.5 2.5h11v11h-11zM5 8l2 2 4-4',
  'adm-text': 'M4 1.5h5.5L12 4v10.5H4zM9.5 1.5V4H12M6 8h4M6 10.5h4',
  'adm-queue': 'M13.5 8a5.5 5.5 0 1 1-1.6-3.9M13.5 2.5v3h-3',
  'adm-load': 'M2 4h6M11 4h3M9.5 2.5v3M2 12h2M7 12h7M5.5 10.5v3',
  'adm-info': 'M8 14.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13zM8 7.5v3.5M8 5v.5',
  'adm-error': 'M8 14.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13zM8 5v3.5M8 10.5v.5',
} as const

export type IconName = keyof typeof PATHS

/** Иконка раздела меню по ключу заголовка навигации. */
export const SECTION_ICONS: Record<string, IconName> = {
  'nav.section.sales': 'sales',
  'nav.section.billing': 'finance',
  'nav.section.warehouse': 'stock',
  'nav.section.hr': 'hr',
  'nav.section.analytics': 'analytics',
  'nav.section.payments': 'payments',
  'nav.section.work': 'work',
  'nav.section.admin': 'admin',
}

export function Icon({
  name,
  size,
  className,
}: {
  name: IconName
  size?: 'sm' | 'xs'
  className?: string
}) {
  const classes = ['i', size ? `i-${size}` : '', className ?? ''].filter(Boolean).join(' ')
  return (
    <svg className={classes} viewBox="0 0 16 16" aria-hidden="true" focusable="false">
      <path d={PATHS[name]} />
    </svg>
  )
}
